import { WorkspaceFontMeta } from 'types'

const VITE_GOOGLE_FONTS_KEY = 'AIzaSyAYpuSgxL2YhpFaVuIsxPpLgPTri40GQP4'
const fontBaseUrl = `https://www.googleapis.com/webfonts/v1/webfonts?key=${VITE_GOOGLE_FONTS_KEY}`

export function getGoogleFont(family: string): Promise<WorkspaceFontMeta> {
  return fetch(`${fontBaseUrl}&family=${family}`)
    .then(res => res.json())
    .then(data => {
      const { family, files, version } = data.items?.[0] || {}
      return { family, files, version, type: 'google' }
    })
}

export function loadFont(font: WorkspaceFontMeta) {
  const { family, files } = font
  const styleId = `font-${family.replace(/\s+/g, '-')}`
  if (document.getElementById(styleId)) return

  const fontFace = Object.entries(files).reduce((acc, [variant, url]) => {
    let weight = variant
    let style = 'normal'
    if (weight.includes('italic')) {
      weight = weight.replace('italic', '') || 'normal'
      style = 'italic'
    }

    return (
      acc +
      `
@font-face {
    font-family: '${family}';
    src: url('${url}');
    font-weight: ${weight};
    font-style: ${style};
}`
    )
  }, '')

  const style = document.createElement('style')
  style.id = styleId
  style.appendChild(document.createTextNode(fontFace))
  document.head.appendChild(style)
}
